import styled from "styled-components";
import Button from "@mui/material/Button";
import { CSVLink } from "react-csv";
import moment from "moment";
import IconUpload from "src/icons/IconUpload";
import CircularProgress from "@mui/material/CircularProgress";

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 0px;
  width: 200px;
  margin-left: ${({ mobile }) => (mobile ? "0" : "auto")};
  cursor: ${({ dataList }) => (dataList.length > 0 ? "pointer" : "no-drop ")};

  .Button-Add {
    color: ${({ color }) => color};
    width: 100%;
    background: ${({ backgrounColor }) => backgrounColor};
    border: 1px solid ${({ borderColor }) => borderColor};
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-Add:focus {
    background-color: ${({ backgrounColor }) => backgrounColor};
  }
  .Button-Add:hover {
    background-color: ${({ backgrounColor }) => backgrounColor};
    opacity: 0.9;
  }

  @media (max-width: 767px) {
    display: ${({ mobile }) => (mobile ? "flex" : "none")};
    width: 100%;
  }
`;

const ExportCsvButton = ({
  dataList = [],
  formatDataCsv = [],
  mobile = false,
  isSmallerThanTablet = false,
  topic = "",
  isLoading = false,
}) => {
  return (
    <WrapperButton
      dataList={dataList}
      backgrounColor={dataList.length > 0 ? "#e04132" : "#D8D8DC"}
      color="white"
      mobile={mobile}
    >
      <Button
        className="Button-Add"
        startIcon={<IconUpload />}
        onClick={() => {
          if (dataList.length < 1) {
            return;
          }
        }}
      >
        {isLoading ? (
          <CircularProgress size={12} color="inherit" />
        ) : (
          <CSVLink
            style={{
              display: "flex",
              fontWeight: "500",
              fontSize: isSmallerThanTablet ? "0.75rem" : "1rem",
              alignItems: "center",
              color: "#ffffff",
              background: "e04132",
              fontStyle: "normal",
              whiteSpace: "nowrap",
              textTransform: "none",
              cursor: dataList.length > 0 ? "pointer" : "no-drop",
            }}
            // data={data}
            data={formatDataCsv}
            // data={"mock mock mock"}
            filename={`${topic}-XSURFACE-${moment(new Date()).format("DD-MM-YYYY")}.csv`}
            // headers={headers}
            onClick={(event, done) => {
              if (dataList?.length === 0) {
                return false;
              }
            }}
          >
            Export To CSV
          </CSVLink>
        )}
      </Button>
    </WrapperButton>
  );
};

export default ExportCsvButton;
